import { Attendance } from '@ice-web-app/assets';
import { UsePopoverReturn } from '@ice-web-app/shared-hooks';
import { Menu, Stack } from '@mui/material';
import { FC } from 'react';
import QuickLink from '../vertical/miniNavbar/Links/QuickLink';

type Props = {
  popover: UsePopoverReturn;
};

const HeaderAppDropDown: FC<Props> = ({ popover }) => {
  return (
    <Menu
      open={popover.open}
      anchorEl={popover.anchorEl}
      onClose={popover.onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      disableScrollLock
      slotProps={{
        paper: { sx: { mt: 1, p: 2 } },
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row">
          <QuickLink icon={<Attendance />} text="item" width={100} isActive={true} />
          <QuickLink icon={<Attendance />} text="item" width={100} />
          <QuickLink icon={<Attendance />} text="item" width={100} />
        </Stack>
        <Stack direction="row">
          <QuickLink icon={<Attendance />} text="item" width={100} />
          <QuickLink icon={<Attendance />} text="item" width={100} />
          <QuickLink icon={<Attendance />} text="item" width={100} />
        </Stack>
      </Stack>
    </Menu>
  );
};

export default HeaderAppDropDown;
